module.exports = __webpack_public_path__ + "img/yearly-sales.02bcb13d.svg";